import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createPulmonologyRecord as createRecord,
  deletePulmonologyRecord as deleteRecord,
  listPulmonologyRecords,
  PULMONOLOGY_RESOURCES,
  updatePulmonologyRecord as updateRecord,
} from "../api/pulmonologyApi";

const errorMessage = (error, fallback) => ({
  message: error?.response?.data?.message || error?.message || fallback,
});

export const fetchPulmonologyRecords = createAsyncThunk(
  "pulmonology/fetchByPatient",
  async ({ patientId }, { rejectWithValue }) => {
    try {
      if (!patientId) return rejectWithValue({ message: "patientId is required" });
      const entries = await Promise.all(PULMONOLOGY_RESOURCES.map(async (resource) => [
        resource,
        await listPulmonologyRecords(patientId, resource),
      ]));
      return { patientId: String(patientId), records: Object.fromEntries(entries) };
    } catch (error) {
      return rejectWithValue(errorMessage(error, "Failed to load pulmonology records"));
    }
  }
);

export const createPulmonologyRecord = createAsyncThunk(
  "pulmonology/create",
  async (args, { rejectWithValue }) => {
    try {
      if (!args?.patientId || !args?.resource) {
        return rejectWithValue({ message: "patientId and resource are required" });
      }
      return {
        patientId: String(args.patientId),
        resource: args.resource,
        record: await createRecord(args),
      };
    } catch (error) {
      return rejectWithValue(errorMessage(error, "Failed to create pulmonology record"));
    }
  }
);

export const updatePulmonologyRecord = createAsyncThunk(
  "pulmonology/update",
  async (args, { rejectWithValue }) => {
    try {
      return {
        patientId: String(args.patientId),
        resource: args.resource,
        record: await updateRecord(args),
      };
    } catch (error) {
      return rejectWithValue(errorMessage(error, "Failed to update pulmonology record"));
    }
  }
);

export const deletePulmonologyRecord = createAsyncThunk(
  "pulmonology/delete",
  async (args, { rejectWithValue }) => {
    try {
      await deleteRecord(args);
      return { patientId: String(args.patientId), resource: args.resource, id: String(args.id) };
    } catch (error) {
      return rejectWithValue(errorMessage(error, "Failed to delete pulmonology record"));
    }
  }
);